import React from 'react';
// lodash
import _ from 'lodash';
// material-ui
import { ViewColumn, PlaylistAdd, ImportExportOutlined } from '@mui/icons-material';
// component
import CommonInput from '../../component/form/common-input.component';
import Card from './Card';
import { SwitchComponent } from './dish-group-detail';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';
// constant
import { Condiments, FirstMenu, ItemUnit, ITEM_TYPE, MenuDish, SecondMenu, TaxGroup } from '../../models';
// i18n
import i18n from '../../i18n';
// apiManage_rbp
import { apiManage_rbp } from '../../request';
import { PatchDishesParams } from '../../request/api/rbp/menu';
import DishGroupDetail from './dish-group-detail';
import ClassifyMenuLibrary from './classify-menu-library.component';
import BASE_CHECK_TYPE from '../../constants/regular.constant';
import { Box, Grid, Typography } from '@mui/material';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import { ALLERGEN, INGREDIENTS } from '../../static/images/dish-base-data';
import LSM from '../../modules/cache/tool-local-storage';
import ButtonComponent from '../../component/button/button.component';

export default class MenuDishDetail extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.handleSave = _.debounce(this.handleSave, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }
    // 是否意大利国家
    public isItaly = LSM.get(LOCAL_STORAGE_KEYS.RBP_RESTAURANT_COUNTRY) === 'Italy';
    // 修改菜名2
    public editDishName2 = false;
    public state: State = {
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 菜品图片
        avatarUrl: '',
        // 大图
        avatarUrlMax: '',
        // 加载中
        isLoading: false,
        // 套餐区域详情弹窗
        isGroupOpen: false,
        // 基础菜品库弹窗
        isShowClassifyMenuLibrary: false,
        // 是否同步基础菜品库
        isSyncLibrary: false,
    }
    // *********************
    // Life Cycle Function
    // *********************

    componentDidMount() {
        this.init();
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */

    init() {
        const { detail } = this.state;
        detail.item_name1 = detail.item_name1 ?? 'Unnamed';
        detail.item_type = detail.item_type ?? 0;
        detail.price_1 = detail.price_1 ?? 0;
        detail.rule_lnr_max_num = detail.rule_lnr_max_num ?? 9999;
        detail.rule_table_max_num = detail.rule_table_max_num ?? 9999;
        detail.class_id = detail.class_id ?? 6;
        detail.required_condiment = detail.required_condiment || -1;
        detail.major_group = detail.major_group || -1;
        detail.family_group = detail.family_group || -1;
        detail.tax_group = detail.tax_group || -1;
        detail.print_class = detail.print_class || -1;
        detail.special_attributes = detail?.special_attributes || 0;
        if (!detail.item_id) {
            detail.item_name2 = detail.item_name2 ?? 'Unnamed';
        }
        // 处理调味品、菜品标识字段
        if (Object.prototype.toString.call(detail.allergen) === '[object String]') {
            const allergenArr = String(detail.allergen)?.split('*');
            detail.allergen = allergenArr;
        }
        if (Object.prototype.toString.call(detail.other_detail_info) === '[object String]') {
            const otDeInfoArr = String(detail.other_detail_info)?.split('*');
            detail.other_detail_info = otDeInfoArr;
        }

        this.setState({
            detail,
            // avatarUrl: detail.item_id ? `${this.SERVER_URL}/${detail.item_id}_s.jpg?randomId=${Math.random()}` : '',
            // avatarUrlMax: detail.item_id ? `${this.SERVER_URL}/${detail.item_id}.jpg?randomId=${Math.random()}` : '',
        })
    }

    /**
     * 保存
     */
    async onSave() {
        try {
            setLoading(true);
            let saveResult = false;
            const { detail, isSyncLibrary } = this.state;
            const { menuListForSet } = this.props
            // 菜品名称和类型必填
            if (
                (!_.trim(detail.item_name1)) ||
                ((detail.item_type ?? '') === '')
            ) {
                throw i18n.t('input_rule_text_enter_dish_name_reuqired')
            }
            // 意大利--菜品名称1
            if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu2.regular.test(detail.item_name1 ?? ''))) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular2')
            }
            // 意大利--菜品名称2
            if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.item_name2 ?? ''))) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular')
            }
            // 菜品名称，助记码校验
            if (
                // !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.item_name1 ?? '')) ||
                // !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.item_name2 ?? '')) ||
                !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.nlu ?? ''))
            ) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular')
            }
            // 菜品详情
            let result;
            // 菜品图片
            let imageResult;
            // 编辑
            if (detail.item_id) {
                const { detail } = this.state;
                // const { dishes } = this.props;
                const params: PatchDishesParams[] = [{
                    item_id: detail.item_id,
                    item_name1: detail.item_name1,
                    item_name2: detail.item_name2,
                    item_type: detail.item_type,
                    nlu: detail.nlu,
                    rule_lnr_max_num: detail.rule_lnr_max_num,
                    rule_lnr_limit_price: detail.rule_lnr_limit_price,
                    rule_table_max_num: Number(detail.rule_table_max_num),
                    item_description: detail.item_description,
                    ext_dish_info: detail.ext_dish_info || '',
                    // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                    allergen: Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                        String(detail.allergen) : detail.allergen?.filter(str => ALLERGEN.find(item => item.key === str)).join('*'),
                    other_detail_info: Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                        String(detail.other_detail_info) : detail.other_detail_info?.join('*'),
                    rules_ignore_the_display: detail.rules_ignore_the_display,
                    rule_lnr_limit_enable: detail.rule_lnr_limit_enable,
                    tax_group: detail.tax_group,
                    required_condiment: detail.required_condiment,
                    // unit price takeout 1
                    unit_1: detail.unit_1,
                    price_1: detail.price_1,
                    takeout_price_1: detail.takeout_price_1,
                    // unit price takeout 2
                    unit_2: detail.unit_2,
                    price_2: detail.price_2,
                    takeout_price_2: detail.takeout_price_2,
                    // unit price takeout 3
                    unit_3: detail.unit_3,
                    price_3: detail.price_3,
                    takeout_price_3: detail.takeout_price_3,
                    // unit price takeout 4
                    unit_4: detail.unit_4,
                    price_4: detail.price_4,
                    takeout_price_4: detail.takeout_price_4,
                    // unit price takeout 5
                    unit_5: detail.unit_5,
                    price_5: detail.price_5,
                    takeout_price_5: detail.takeout_price_5,
                    // 自定义报表主类别
                    major_group: detail.major_group,
                    // 自定义报表子类别
                    family_group: detail.family_group,
                    // 打印组(岗位)
                    print_class: detail.print_class,
                    class_id: detail.class_id || 0,
                    special_attributes: detail?.special_attributes || 0,
                }]
                const imageParams: string[] = [`${detail.item_id}_s`, `${detail.item_id}`];
                // dishes.forEach((item) => {
                //     // 修改其他复制品的信息
                //     if (item.item_id !== this.props.detail.item_id) {
                //         params.push({
                //             item_id: item.item_id,
                //             item_name1: detail.item_name1,
                //             item_name2: detail.item_name2,
                //             item_type: detail.item_type,
                //             unit_1: detail.unit_1,
                //             item_description: detail.item_description,
                //             ext_dish_info: detail.ext_dish_info,
                //             allergen: Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                //                 String(detail.allergen) : detail.allergen?.filter(str => ALLERGEN.find(item => item.key === str)).join('*'),
                //             other_detail_info: Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                //                 String(detail.other_detail_info) : detail.other_detail_info?.join('*'),
                //         })
                //     }
                //     imageParams.push(`${item.item_id}_s,`, `${item.item_id}`);
                // })
                result = await apiManage_rbp.patch_dishes(params);
                imageResult = await this.updateImage(imageParams.toString())
            }
            // 新增
            else {
                // 获取菜单的菜品不受轮次限制的设置  notJoiningGlobalLimitSet 菜品不受轮次限制设置  新增菜品时加入设置好的参数
                let notJoiningGlobalLimitSet: number | undefined = 0;
                menuListForSet.find((item: FirstMenu) => {
                    item.menu_item_slu?.forEach((element: SecondMenu) => {
                        notJoiningGlobalLimitSet = element.not_joining_global_limit
                    })
                    return notJoiningGlobalLimitSet;
                })
                detail.item_name2 = detail.item_name2 || detail.item_name1;
                // 参数做处理 过敏原和其他菜品标识要传字符串
                const params: PatchDishesParams = {
                    ...detail,
                    item_name2: detail.item_name2 || detail.item_name1,
                    // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                    allergen: Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                        String(detail.allergen) : detail.allergen?.join('*'),
                    other_detail_info: Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                        String(detail.other_detail_info) : detail.other_detail_info?.join('*'),
                    required_condiment: detail.required_condiment,
                    scomdiment_groups_id: undefined,
                    not_joining_global_limit: notJoiningGlobalLimitSet
                }
                result = await apiManage_rbp.post_dishes(params);
                detail.item_id = result.insertId;
                imageResult = await this.updateImage(`${result.insertId}_s,${result.insertId}`);
            }
            // 请求成功
            if (!_.get(result, 'error') && imageResult) {
                // 同步基础菜品库
                if (isSyncLibrary) {
                    const curDetail = _.cloneDeep(detail);
                    const sluId = curDetail.slu_id ? String(curDetail.slu_id) : '';
                    // 删除菜品库无用字段
                    delete curDetail.slu_id;
                    delete curDetail.item_id;
                    delete curDetail.rule_lnr_limit_enable;
                    delete curDetail.rules_ignore_the_display;
                    // 参数做处理 过敏原和其他菜品标识要传字符串
                    const params: PatchDishesParams[] = [{
                        ...curDetail,
                        // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                        allergen: Object.prototype.toString.call(curDetail.allergen) === '[object String]' ?
                            String(curDetail.allergen) : curDetail.allergen?.join('*'),
                        other_detail_info: Object.prototype.toString.call(curDetail.other_detail_info) === '[object String]' ?
                            String(curDetail.other_detail_info) : curDetail.other_detail_info?.join('*'),
                        required_condiment: curDetail.required_condiment,
                        slu_ids: sluId,
                        item_ids: `${detail.item_id}`
                    }]
                    const syncResult = await apiManage_rbp.post_menu_library(params);
                    const insertId = _.get(syncResult, '[0]', null)
                    detail.id = insertId;
                    const syncImageResult = await this.updateImage(`${insertId}_s,${insertId}`);
                    if (_.get(syncResult, 'error') || !syncImageResult) {
                        GlobalNotification.error(i18n.t('menu_and_dishes_page_dish_sync_basic_dishes_store_faile'));
                    }
                }
                saveResult = true;
                // 刷新数据
                this.props.getMenuData();
                this.setState({
                    detail,
                    avatarFile: undefined,
                })
            }
            // 请求失败
            else {
                saveResult = false;
                throw i18n.t('global_text_operate_failure')
            }
            return saveResult
        }
        catch (error) {
            GlobalNotification.error(error as string);
            return;
        } finally {
            setLoading(false);
        }
    }


    /**
     * 上传菜品图片
     */
    async updateImage(dishId: string) {
        let result = true;
        const { avatarFile } = this.state;
        if (avatarFile) {
            const imageResult = await apiManage_rbp.post_dishes_image(dishId, avatarFile);
            // 上传失败
            if (_.get(imageResult, 'error')) {
                result = false;
            }
        }
        return result
    }

    /**
     * 表单回调
     * @param value
     * @param key
     */
    onChange(value: number | string | string[], key: string) {
        const { detail } = this.state;
        const propDetail = this.props.detail;
        let newValue = value;
        // 价格做处理
        if (
            (key === 'price_1') || (key === 'takeout_price_1') ||
            (key === 'price_2') || (key === 'takeout_price_2') ||
            (key === 'price_3') || (key === 'takeout_price_3') ||
            (key === 'price_4') || (key === 'takeout_price_4') ||
            (key === 'price_5') || (key === 'takeout_price_5') || (key === 'rule_lnr_limit_price')
        ) {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(2))
            }
        }
        // 数量做处理
        if (key === 'rule_lnr_max_num' || key === 'rule_table_max_num') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(0))
            }
        }
        _.set(detail, key, newValue);
        // 同步外卖价格
        if (key === 'price_1') !propDetail.takeout_price_1 && _.set(detail, 'takeout_price_1', newValue);
        if (key === 'price_2') !propDetail.takeout_price_2 && _.set(detail, 'takeout_price_2', newValue);
        if (key === 'price_3') !propDetail.takeout_price_3 && _.set(detail, 'takeout_price_3', newValue);
        if (key === 'price_4') !propDetail.takeout_price_4 && _.set(detail, 'takeout_price_4', newValue);
        if (key === 'price_5') !propDetail.takeout_price_5 && _.set(detail, 'takeout_price_5', newValue);
        if (key === 'item_name2' && !propDetail.item_id) this.editDishName2 = !!newValue
        // 同步菜名2
        if (!propDetail.item_id && key === 'item_name1') !this.editDishName2 && _.set(detail, 'item_name2', value);
        this.setState({
            detail
        }, () => {
            // 套餐不支持同步基础菜品库
            if (detail.item_type === 3) {
                this.setState({
                    isSyncLibrary: false,
                })
            }
        })
    }

    /**
     * 删除菜品图片
     */
    async deleteImage() {
        const { detail, avatarFile } = this.state;
        if (detail.item_id) {
            if (avatarFile) {
                this.setState({
                    avatarUrl: '',
                    avatarUrlMax: '',
                    avatarFile: undefined
                })
            }
            else {
                setLoading(true);
                // const result = await apiManage_rbp.delete_dishes_image(detail.item_id);
                // 删除成功
                // if (result) {
                //     GlobalNotification.success(i18n.t('global_text_operate_success'));
                //     this.setState({
                //         avatarUrl: `${this.SERVER_URL}/${detail.item_id}_s.jpg?randomId=${Math.random()}`,
                //         avatarUrlMax: `${this.SERVER_URL}/${detail.item_id}.jpg?randomId=${Math.random()}`
                //     })
                // }
                // else {
                //     GlobalNotification.error(i18n.t('global_text_operate_failure'));
                // }
                setLoading(false);
            }

        }
        else {
            this.setState({
                avatarUrl: '',
                avatarUrlMax: '',
                avatarFile: undefined
            })
        }

    }

    /**
     * 创建套餐区域
     */
    async addCourseGroup() {
        this.setState({
            isGroupOpen: true
        })
    }

    /**
     * 保存按钮操作
     * @returns
     */
    async handleSave() {
        if (this.state.isLoading) {
            return;
        }
        this.setState({
            isLoading: true
        })
        const result = await this.onSave();
        if (result) {
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            // 返回上一层
            this.props.handleClickBack()
        }

        this.setState({
            isLoading: false,
            isSyncLibrary: false
        })

    }

    /**
     * 编辑套餐区域
     */
    async handleEditCourse() {
        if (this.state.isLoading) {
            return;
        }
        this.setState({
            isLoading: true
        }, async () => {
            const result = await this.onSave();
            this.setState({
                isLoading: false,
                isGroupOpen: !!result,
            })
        })
    }

    /**
     * 导入基础菜品
     * @param inMenuItem
     */
    public setItemFromMenuLiabrary(inMenuItem: MenuDish) {
        if (_.isEmpty(inMenuItem)) {
            GlobalNotification.warning(i18n.t('menu_and_dishes_page_please_select_import_dish'));
            return;
        }
        // ! 防止类型报错，可能与MenuDish中类型不一致！！！
        // 处理调味品、菜品标识字段
        if (Object.prototype.toString.call(inMenuItem.allergen) === '[object String]') {
            const allergenArr = String(inMenuItem.allergen)?.split('*');
            inMenuItem.allergen = allergenArr;
        }
        if (Object.prototype.toString.call(inMenuItem.other_detail_info) === '[object String]') {
            const otDeInfoArr = String(inMenuItem.other_detail_info)?.split('*');
            inMenuItem.other_detail_info = otDeInfoArr;
        }
        // TODO 暂定直接覆盖
        const { detail } = this.state;
        const afterDetail: MenuDish = {
            item_id: detail.item_id,
            slu_id: detail.slu_id,
            item_name1: inMenuItem.item_name1,
            item_name2: inMenuItem.item_name2,
            item_type: inMenuItem.item_type,
            required_condiment: inMenuItem.required_condiment || -1,
            nlu: inMenuItem.nlu,
            rule_lnr_max_num: inMenuItem.rule_lnr_max_num,
            rule_table_max_num: inMenuItem.rule_table_max_num,
            rule_lnr_limit_price: inMenuItem.rule_lnr_limit_price,
            item_description: inMenuItem.item_description,
            ext_dish_info: inMenuItem.ext_dish_info,
            allergen: inMenuItem.allergen,
            other_detail_info: inMenuItem.other_detail_info,
            rules_ignore_the_display: inMenuItem.rules_ignore_the_display,
            rule_lnr_limit_enable: inMenuItem.rule_lnr_limit_enable,
            tax_group: inMenuItem.tax_group,
            // unit price takeout 1
            unit_1: inMenuItem.unit_1,
            price_1: inMenuItem.price_1,
            takeout_price_1: inMenuItem.takeout_price_1,
            // unit price takeout 2
            unit_2: inMenuItem.unit_2,
            price_2: inMenuItem.price_2,
            takeout_price_2: inMenuItem.takeout_price_2,
            // unit price takeout 3
            unit_3: inMenuItem.unit_3,
            price_3: inMenuItem.price_3,
            takeout_price_3: inMenuItem.takeout_price_3,
            // unit price takeout 4
            unit_4: inMenuItem.unit_4,
            price_4: inMenuItem.price_4,
            takeout_price_4: inMenuItem.takeout_price_4,
            // unit price takeout 5
            unit_5: inMenuItem.unit_5,
            price_5: inMenuItem.price_5,
            takeout_price_5: inMenuItem.takeout_price_5,
            print_class: inMenuItem.print_class,
            class_id: inMenuItem.class_id,
            special_attributes: inMenuItem.special_attributes || 0
        }
        this.setState({
            detail: afterDetail,
            isShowClassifyMenuLibrary: false,
        })
    }

    // *********************
    // View
    // *********************

    render() {
        const { detail, isGroupOpen, isShowClassifyMenuLibrary, isSyncLibrary } = this.state;
        // 税率组
        const taxGroup = this.props.taxGroup.map((item) => ({
            label: item.tax_group_name || '',
            value: item.tax_group_id || 0
        }));
        taxGroup.unshift({
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified')
        })
        // 调味品组
        const condimentsGroup = this.props.condimentsGroup.map((item) => ({
            label: item.comdiment_groups_name || '',
            value: item.scomdiment_groups_id || -1
        }));
        // 打印组
        const printGroup = this.props.printGroup?.map((item) => ({
            label: item.print_class_name || '',
            value: item.print_class_id || 0
        }))
        // 菜品规格列表
        // const priceSpecList = this.props.priceSpecList.map((item) => ({
        //     label: item.unit_name || '',
        //     // ? value 暂定绑名称，因为聚客设置时写死
        //     value: item.unit_name || '',
        // }))
        // 自定义报表主类型列表
        const majorGroup = this.props.majorGroup.map((item) => ({
            label: item.major_group_name || '',
            value: item.major_group_id || 0
        }));
        // 自定义报表子类型列表
        const mergetypes = this.props.mergetypes.map((item) => ({
            label: item.family_group_name || '',
            value: item.family_group_id || 0
        }));
        // 表单
        const formArr1 = [
            {
                key: 'item_name1',
                label: i18n.t('menu_and_dishes_page_item_name1'),
                regularType: this.isItaly ? 'dishNameAndNlu2' : 'required',
                require: true,
            },
            {
                key: 'item_name2',
                label: i18n.t('menu_and_dishes_page_dish_name2'),
                regularType: this.isItaly ? 'dishNameAndNlu' : 'undefined'
            },
            {
                key: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                select: true,
                items: ITEM_TYPE,
                require: true,
                regularType: 'required',
            },
            {
                key: 'tax_group',
                label: i18n.t('tax_group_page_label'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: taxGroup,
            },
            {
                key: 'print_class',
                label: i18n.t('menu_and_dishes_page_print_class'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: printGroup,
            },
            {
                key: 'nlu',
                label: i18n.t('rwa_setting_page_mnemonic_code'),
                regularType: 'dishNameAndNlu',
            },
        ]
        // 表单
        const formArr2 = [
            // {
            //     key: 'unit_1',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 1`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            {
                key: 'price_1',
                label: `${i18n.t('menu_and_dishes_page_price')}`,
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'takeout_price_1',
                label: `${i18n.t('menu_and_dishes_page_takeout_price')}`,
                width: 4 as const,
                type: 'number'
            },
            // {
            //     key: 'unit_2',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 2`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_2',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 2`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_2',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 2`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_3',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 3`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_3',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 3`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_3',
            //     label:`${i18n.t('menu_and_dishes_page_takeout_price')} 3`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_4',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 4`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_4',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 4`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_4',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 4`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_5',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 5`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_5',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 5`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_5',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 5`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            {
                key: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'rule_table_max_num',
                label: i18n.t('menu_and_dishes_page_table_max_num'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'rule_lnr_limit_price',
                label: i18n.t('menu_and_dishes_page_extra_price'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'required_condiment',
                label: i18n.t('condiment_page_group_optional'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: condimentsGroup,
            },
            {
                key: 'class_id',
                label: i18n.t('menu_and_dishes_page_menu_dish_has_discount'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: [
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 6 },
                    { label: i18n.t('menu_and_dishes_page_has_not_discount'), value: 3 }
                ],
            },
            {
                key: 'major_group',
                label: i18n.t('condiment_page_custom_form_main_type'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: majorGroup,
            },
            {
                key: 'family_group',
                label: i18n.t('condiment_page_custom_form_sub_type'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: mergetypes,
            },
            {
                key: 'special_attributes',
                label: i18n.t('menu_and_dishes_page_special_attribute'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: [
                    { label: i18n.t('print_setting_page_none0'), value: 0 },
                    { label: i18n.t('menu_and_dishes_page_chef_recommendation'), value: 1 },
                    { label: i18n.t('menu_and_dishes_page_new_menu_recommendation'), value: 2 },
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 3 }
                ],
            },
            {
                key: 'item_description',
                label: i18n.t('google_text_dish_remarks'),
                width: 12 as const,
            },
            {
                key: 'ext_dish_info',
                label: i18n.t('menu_and_dishes_page_other_dish_mark'),
                width: 12 as const,
            },
            {
                key: 'allergen',
                label: i18n.t('menu_and_dishes_page_allergen'),
                width: 12 as const,
                inputType: 'SELECT_MUL' as const,
                options: ALLERGEN.map((item) => ({
                    value: item.key,
                    label: i18n.t(item.text),
                    icon: <img style={{ width: 20, height: 20 }} alt={item.key} src={item.icon} />
                }))
            },
            {
                key: 'other_detail_info',
                label: i18n.t('menu_and_dishes_page_other_dish_pin'),
                width: 12 as const,
                inputType: 'SELECT_MUL' as const,
                options: INGREDIENTS.map((item) => ({
                    value: item.key,
                    label: i18n.t(item.text),
                    icon: <img style={{ width: 20, height: 20 }} alt={item.key} src={item.icon} />
                }))
            }
        ]
        return (
            <div>
                <Card
                    title={(
                        <Box display='flex' alignItems='center'>
                            <ButtonComponent
                                action='BACK'
                                handleClick={() => {
                                    this.props.handleClickBack()
                                }}
                            />
                            <Typography>
                                {(detail.item_id || (detail.item_id === 0)) ? i18n.t('menu_and_dishes_page_edit_dish') : i18n.t('menu_and_dishes_page_add_dish')}
                            </Typography>
                        </Box>
                    )}
                    actionRender={(
                        <>
                            {/* 新增菜品才可同步到基础菜品库 */}
                            {
                                // 套餐不支持同步基础菜品库
                                (!detail.item_id && detail.item_type !== 3) &&
                                <SwitchComponent
                                    value={isSyncLibrary}
                                    label={i18n.t('menu_and_dishes_page_sync_basic_dishes_store')}
                                    onChange={(e, checked) => {
                                        this.setState({
                                            isSyncLibrary: checked,
                                        })
                                    }}
                                />
                            }
                            {
                                detail.item_type === 3 &&
                                <ButtonComponent
                                    titleText={i18n.t('menu_and_dishes_page_edit_set_meal_area')}
                                    children={<PlaylistAdd />}
                                    handleClick={() => { this.handleEditCourse() }}
                                />
                            }
                            {
                                (detail.item_id || (detail.item_id === 0)) && this.props.dishes.length > 1 &&
                                <ButtonComponent
                                    titleText={i18n.t('menu_and_dishes_page_change_edit_mode')}
                                    children={<ViewColumn />}
                                    handleClick={this.props.handleChangeMode}
                                />
                            }
                            <ButtonComponent
                                titleText={i18n.t('menu_and_dishes_page_import_basic_dish')}
                                children={<ImportExportOutlined />}
                                handleClick={() => { this.setState({ isShowClassifyMenuLibrary: true }) }}
                            />
                            <ButtonComponent
                                action='SAVE'
                                handleClick={async () => { await this.handleSave() }}
                            />
                        </>
                    )}
                    contentRender={(
                        <Grid container spacing={2} >
                            {/* <Grid item>
                                <AvatarCard
                                    avatarUrl={avatarUrl}
                                    avatarUrlMax={avatarUrlMax}
                                    onChangeAvatarUrl={(url, file) => {
                                        this.setState({
                                            avatarUrl: url,
                                            avatarUrlMax: url,
                                            avatarFile: file
                                        })
                                    }}
                                    onDelete={() => {
                                        this.deleteImage()
                                    }}
                                />
                            </Grid> */}
                            <Grid container item xs={12} spacing={4}>
                                {
                                    formArr1.map((item, index) => (
                                        <Grid item xs={12} md={4} key={index} >
                                            <CommonInput
                                                type={item.type}
                                                select={item.select}
                                                items={item.items}
                                                required={item.require}
                                                regularType={i18n.t(item.regularType ?? '')}
                                                variant={'outlined'}
                                                fullWidth
                                                label={item.label}
                                                value={_.get(detail, item.key) ?? ''}
                                                onChange={(event: any) => {
                                                    this.onChange(event.target.value, item.key)
                                                }}
                                            />
                                        </Grid>
                                    ))
                                }
                                {
                                    formArr2.map((item) => {
                                        const selectValue: any[] = [];
                                        if (item.inputType === 'SELECT_MUL') {
                                            const v: string[] = _.get(detail, item.key, []);
                                            item.options.forEach((iitem) => {
                                                if (iitem.value && v?.includes(iitem.value)) {
                                                    selectValue.push(iitem);
                                                }
                                            })
                                        }
                                        const onChange = (value) => {
                                            if (item.inputType === 'SELECT_MUL') {
                                                const newValue = value.map((item: any) => (item.value))
                                                this.onChange(newValue, item.key)
                                            }
                                            else {
                                                this.onChange(value.target.value, item.key)
                                            }
                                        }
                                        return (
                                            <Grid item xs={12} md={item.width} key={item.key}>
                                                <CommonInput
                                                    type={item.type}
                                                    select={item.select}
                                                    items={item.items}
                                                    inputType={item.inputType}
                                                    variant={'outlined'}
                                                    fullWidth
                                                    label={item.label}
                                                    value={item.inputType === 'SELECT_MUL' ? selectValue : (_.get(detail, item.key) ?? '')}
                                                    multipleProps={{
                                                        options: item.options!,
                                                        onChange
                                                    }}
                                                    onChange={onChange}
                                                />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            <Grid item>
                                <SwitchComponent
                                    value={detail.rule_lnr_limit_enable === 1}
                                    label={i18n.t('menu_and_dishes_page_continue_to_add')}
                                    onChange={(e, checked) => {
                                        this.onChange(Number(checked), 'rule_lnr_limit_enable')
                                    }}
                                />
                            </Grid>
                            <Grid item>
                                <SwitchComponent
                                    value={detail.rules_ignore_the_display === 1}
                                    label={i18n.t('menu_and_dishes_page_dish_edition_ignore_turn_rule')}
                                    onChange={(e, checked) => {
                                        this.onChange(Number(checked), 'rules_ignore_the_display')
                                    }}
                                />
                            </Grid>
                        </Grid>)
                    }
                />
                {
                    isGroupOpen &&
                    <DishGroupDetail
                        menuData={this.props.menuListForSet}
                        dishDetail={this.state.detail}
                        open={isGroupOpen}
                        onCancel={() => {
                            this.setState({
                                isGroupOpen: false
                            })
                        }}
                    />
                }
                {
                    isShowClassifyMenuLibrary &&
                    <ClassifyMenuLibrary
                        open={isShowClassifyMenuLibrary}
                        onCancel={() => {
                            this.setState({
                                isShowClassifyMenuLibrary: false,
                            })
                        }}
                        getMenuData={this.props.getMenuData}
                        menuData={this.props.menuData}
                        taxGroup={this.props.taxGroup}
                        condimentsGroup={this.props.condimentsGroup}
                        printGroup={this.props.printGroup}
                        priceSpecList={this.props.priceSpecList}
                        disableEdit={true}
                        onFtConfirm={(detailData: MenuDish) => {
                            this.setItemFromMenuLiabrary(detailData);
                        }}
                    />
                }
            </div>
        )
    }
    getMenuData() {
        throw new Error('Method not implemented.');
    }
}

// *********************
// Type
// *********************
type Props = {
    // 菜品详情
    detail: MenuDish;
    // 返回
    handleClickBack: () => void;
    // 切换显示模式
    handleChangeMode: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 更新当前显示的菜品详情
    updateDetail: (detail: MenuDish) => void;
    // 税率组
    taxGroup: TaxGroup[];
    // 不同菜单同一菜品
    dishes: MenuDish[];
    // 菜单数据（含菜品，供套餐选择菜品使用）
    menuListForSet: FirstMenu[];
    // 菜单源数据
    menuData: FirstMenu[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 打印组(岗位)
    printGroup: any[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 报表主类别
    majorGroup: any[];
    // 报表子类别
    mergetypes: any[];
}
type State = {
    // 菜品详情
    detail: MenuDish
    // 菜品图片
    avatarUrl: string;
    // 大图
    avatarUrlMax: string;
    // 菜品图片文件
    avatarFile?: File;
    // 加载中
    isLoading: boolean;
    // 套餐区域详情弹窗
    isGroupOpen: boolean;
    // 基础菜品库弹窗
    isShowClassifyMenuLibrary: boolean;
    // 是否同步基础菜品库
    isSyncLibrary: boolean;
}